<div class="marketing-tab">
  <div class="toolbar">
    <div>
      <h3 class="section-title">Groups</h3>
      <div class="subtitle">Reusable audience groups for campaign targeting.</div>
    </div>
    <div class="actions">
      <mat-form-field appearance="fill">
        <mat-label>Status</mat-label>
        <mat-select
          [(ngModel)]="groupArchiveStatusFilter"
          (selectionChange)="onArchiveStatusFilterChange()"
          >
          @for (option of archiveStatusOptions; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button mat-raised-button color="primary" (click)="add()">
        <mat-icon>add</mat-icon>
        Create new Group
      </button>
    </div>
  </div>

  <div class="summary-grid">
    <div class="summary-item">
      <span class="label">Groups</span>
      <strong>{{ tableDataSource.data.length }}</strong>
    </div>
    <div class="summary-item">
      <span class="label">Types</span>
      <strong>{{ getGroupTypeCount() }}</strong>
    </div>
    <div class="summary-item">
      <span class="label">Email/SMS groups</span>
      <strong>{{ getMemberTypeCount('emailAddress') }}</strong>
    </div>
  </div>

  <div class="table-wrap">
    <table class="table" mat-table matSort matSortActive="name" matSortDirection="asc" [dataSource]="tableDataSource">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td class="cell" mat-cell *matCellDef="let item">
          <div class="cell-primary">{{item.name}}</div>
          <div class="cell-secondary">{{item.members?.length || 0}} members</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td class="cell description" mat-cell *matCellDef="let item">
          {{item.description || '-'}}
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td class="cell" mat-cell *matCellDef="let item">
          <span class="status-pill" [ngClass]="getStatusClass(getStatusLabel(item))">
            {{ getStatusLabel(item) }}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="memberType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td class="cell" mat-cell *matCellDef="let item">
          <span class="type-pill">{{getTypeName(item.memberType)}}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>
        <td class="cell" mat-cell *matCellDef="let item">
          {{ item.createdAt ? (item.createdAt | date:'medium') : '-' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actionmenu" stickyEnd>
        <th mat-header-cell matTooltip="Actions" *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button
            mat-icon-button
            class="action-button"
            [matMenuTriggerFor]="menu"
            [matMenuTriggerData]="{item: item}"
            aria-label="Group actions"
            (click)="$event.stopPropagation()"
            >
            <mat-icon matTooltip="Actions" class="more">more_vert</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
      <tr class="listitem" mat-row *matRowDef="let rows; columns: columnNames"></tr>
    </table>
    @if (tableDataSource.data.length === 0) {
      <div class="empty">
        No marketing groups have been created yet.
      </div>
    }
    <mat-menu #menu="matMenu">
      <ng-template matMenuContent let-item="item">
        <button mat-menu-item (click)="edit(item)">
          <mat-icon>edit</mat-icon>
          Edit
        </button>
        @if (!isArchived(item)) {
          <button mat-menu-item (click)="archive(item)">
            <mat-icon>archive</mat-icon>
            Archive
          </button>
        }
      </ng-template>
    </mat-menu>
  </div>
</div>
